import { FormButton as ExprWorksFormButton } from '@diagentech/exprworks-ui-components';

import { withDisplayRule } from '@/features/displayRules/withDisplayRule';

export const FormButton = withDisplayRule(ExprWorksFormButton);
